var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurbhubPackagesDetailsBar1Check(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 141,
    viewBox: "0 0 18 141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_555",
    "data-name": "Grupo 555",
    transform: "translate(-20 -521)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_15",
    "data-name": "Elipse 15",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(20 521)",
    fill: "#7fc15e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_11",
    "data-name": "L\\xEDnea 11",
    y2: 133,
    transform: "translate(29 529)",
    fill: "none",
    stroke: "#7fc15e",
    strokeWidth: 2,
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "tick",
    transform: "translate(-151 30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(173.761 495.762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0.075 0.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_59",
    "data-name": "Trazado 59",
    d: "M4.694,8.4a.618.618,0,0,1-.437-.181L.241,4.2a.618.618,0,0,1,.873-.873l3.58,3.58L11.363.241a.618.618,0,0,1,.873.873L5.131,8.22A.618.618,0,0,1,4.694,8.4Z",
    transform: "translate(-0.075 -0.075)",
    fill: "#fafafa"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurbhubPackagesDetailsBar1Check);
export default __webpack_public_path__ + "static/media/curbhub_packages-details_bar_1_check.1ec3d3fa9fc297b8e335e03774256353.svg";
export { ForwardRef as ReactComponent };